import React from 'react';
import PropTypes from "prop-types";
import { faPlus, faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExifReader from 'exifreader';

class UploadButton extends React.Component {

    constructor(props) {
        super(props);
        this.handleFileChanged = this.handleFileChanged.bind(this);
        this.state = { fileName: "Uploaden" };
    }

    async handleFileChanged(event) {
        event.preventDefault();
        const file = event.target.files[0];
        const tags = await ExifReader.load(file, {expanded: true});
        this.setState({ fileName: file.name });
        if (tags?.gps?.Latitude || tags?.gps?.Longitude) {
            this.props.placePinByImage({ pinLat: tags.gps.Latitude, pinLng: tags.gps.Longitude });
        }
        
    }

    render() {
        return (
            <div>
                <label
                    htmlFor="photo_upload">
                    <FontAwesomeIcon icon={this.state.fileName === "Uploaden" ? faPlus : faCamera} size="1x" className="submitIcon" />
                    {this.state.fileName}
                </label>
                <input
                    id="photo_upload"
                    type="file"
                    className="buttonText"
                    name={this.props.name}
                    accept="image/*"
                    onChange={this.handleFileChanged}
                    onInvalid={this.props.onInvalid}
                />
            </div>

        );
    }
}

UploadButton.propTypes = {
    name: PropTypes.string.isRequired,
    placePinByImage: PropTypes.func.isRequired
};

export default UploadButton;